(function () {
  'use strict';
  if (window.kaidoLaunchLifecycle) { window.kaidoLaunchLifecycle.mount(); return; }
  var roots = new Map(), anchor = null, floor = -Infinity, authority = null, flight = null, rerun = false, generation = 0, retryAt = 0, projectionFlight = null;
  var state = { phase: 'unknown', base_rate: 0, validUntil: 0 };
  window.kaidoLifecycleState = state;
  function now() {
    if (!anchor) return NaN;
    floor = Math.max(floor, anchor.time + performance.now() - anchor.mono);
    return floor;
  }
  window.kaidoLifecycleNow = now;
  function publish(next) {
    // Lease renewal alone must not recreate the progress DOM or private reads.
    var fields = ['phase', 'base_rate', 'bonus_end', 'daily_bonus_end', 'social_quantity', 'planned_start', 'giveaway_start', 'giveaway_end'];
    var same = fields.every(function (key) { return state[key] === next[key]; });
    var changedPolicy = state.policy_hash !== next.policy_hash;
    if (same) { state.validUntil = next.validUntil; state.policy_hash = next.policy_hash; }
    else state = next;
    window.kaidoLifecycleState = state;
    roots.forEach(function (item) { if (!same || item.needsPaint) paint(item); });
    if (same && !changedPolicy) return;
    document.dispatchEvent(new CustomEvent('kaido:lifecycle', { detail: state }));
    document.querySelectorAll('[data-kaido-managed-rate]').forEach(function (el) { el.textContent = next.phase === 'active' ? String(next.base_rate) : ''; });
  }
  function clear() { publish({ phase: 'unknown', base_rate: 0, validUntil: 0 }); }
  function text(root, selector, value) { root.querySelectorAll(selector).forEach(function (el) { if (el.textContent !== value) el.textContent = value; }); }
  function hide(el, hidden) { el.hidden = hidden; el.style.display = hidden ? 'none' : ''; }
  function resolveDailyBonusEnd(data, t, raffleEnd) {
    if (!data || data.active !== true || !Array.isArray(data.products) || data.products.length === 0 || typeof data.expires_at !== 'string') return null;
    var expires = Date.parse(data.expires_at);
    return Number.isFinite(expires) && expires > t && expires <= raffleEnd ? data.expires_at : null;
  }
  function timerTarget(current, start, end, home) {
    if (current.phase === 'prestart') return current.giveaway_start || start;
    if (current.phase !== 'active') return null;
    return home && current.daily_bonus_end ? current.daily_bonus_end : current.giveaway_end || end;
  }
  function timerLabel(current, home) {
    if (current.phase === 'prestart') return current.planned_start ? 'PLANNED START IN' : 'GIVEAWAY STARTS IN';
    if (current.phase !== 'active') return '';
    return home && current.daily_bonus_end ? 'BONUS ENTRIES END IN' : 'GIVEAWAY ENDS IN';
  }
  function paint(item) {
    item.needsPaint = false;
    var root = item.root, active = state.phase === 'active', home = item.cfg.kind === 'home';
    if (item.progress && (!active || !item.progress.container.isConnected || item.progress.lease !== state)) { item.progress.dispose(); item.progress = null; }
    if (home && active !== item.active) {
      var content = root.querySelector('.kh3__content');
      if (content && item.activeTemplate) content.replaceChildren((active ? item.activeTemplate.content : item.before).cloneNode(true));
      root.classList.remove('kh3--' + (item.active ? 'active-' + item.cfg.activeLayout : 'teaser-' + item.cfg.teaserLayout));
      root.classList.add('kh3--' + (active ? 'active-' + item.cfg.activeLayout : 'teaser-' + item.cfg.teaserLayout));
      root.setAttribute('data-kh3-phase', active ? 'active' : 'teaser'); item.active = active;
      root.setAttribute('data-kh3-layout', active ? item.cfg.activeLayout : item.cfg.teaserLayout);
    }
    root.setAttribute('data-kaido-state', state.phase);
    if (home) text(root, '.kh3__subheading', state.phase === 'ended' ? 'GIVEAWAY ENDED' : state.phase === 'unknown' ? 'FETCHING GIVEAWAY STATUS' : active ? item.originalSubheading.replace(/^UPCOMING GIVEAWAY$/, 'KMG8 GIVEAWAY') : item.originalSubheading);
    var target = timerTarget(state, item.cfg.start, item.cfg.end, home);
    var remaining = target ? Math.max(0, Date.parse(target) - now()) : 0;
    var prefix = home ? 'kh3' : 'kgh';
    var timer = root.querySelector('[role="timer"]') || root.querySelector('[id^="kghCountdown-"]');
    if (timer) hide(timer, !target);
    text(root, home ? '.kh3__countdown-head' : '.kgh__countdown-head', timerLabel(state, home));
    root.querySelectorAll('[href*="claim-free-entry"]').forEach(function (el) { hide(el, !active); });
    root.querySelectorAll('[data-kgh-badge-source="social_bonus"]').forEach(function (el) { hide(el, !active || !state.social_quantity); text(el, '.kgh__badge-value', state.social_quantity ? String(state.social_quantity) : ''); });
    [Math.floor(remaining / 86400000), Math.floor(remaining / 3600000) % 24, Math.floor(remaining / 60000) % 60, Math.floor(remaining / 1000) % 60].forEach(function (value, i) {
      text(root, '[data-' + prefix + '-' + ['days', 'hours', 'mins', 'secs'][i] + ']', String(value).padStart(2, '0'));
    });
    root.querySelectorAll('.kh3__entry-badge').forEach(function (badge) {
      var label = badge.lastElementChild && badge.lastElementChild.textContent.toLowerCase();
      if (label && label.indexOf('base') >= 0) { hide(badge, !active); text(badge, '.kh3__entry-badge-multiplier', active ? state.base_rate + 'X' : ''); }
      if (label && label.indexOf('social') >= 0) { hide(badge, !active || !state.social_quantity); text(badge, '.kh3__entry-badge-multiplier', state.social_quantity ? String(state.social_quantity) : ''); }
    });
    root.querySelectorAll('[data-kgh-badge-source="entries_per_dollar"]').forEach(function (badge) { hide(badge, !active); text(badge, '.kgh__badge-value', active ? state.base_rate + 'X' : ''); });
    root.querySelectorAll('[id^="kghLive-"]').forEach(function (el) { el.hidden = !active; el.style.display = active ? '' : 'none'; el.setAttribute('aria-hidden', active ? 'false' : 'true'); });
    var bar = root.querySelector('[id^="kh3Progress-"]');
    if (bar) {
      hide(bar, !active); bar.classList.toggle('kh3__progress--bonus', active && !!state.bonus_end);
      if (active && window.KaidoManagedProgress) {
        if (!item.progress || item.progress.container !== bar || item.progress.lease !== state) {
          if (item.progress) item.progress.dispose();
          var progressConfig = Object.assign({}, item.cfg, {
            start: state.giveaway_start || item.cfg.start,
            end: state.giveaway_end || item.cfg.end,
          });
          item.progress = window.KaidoManagedProgress.create(progressConfig, bar, state);
        }
        item.progress.tick();
      } else {
        if (item.progress) item.progress.dispose(); item.progress = null;
        bar.replaceChildren(); bar.setAttribute('aria-hidden', 'true');
      }
    }
  }
  function resolveActiveState(data, cfg, t, start, end) {
    if (typeof data.raffle_id !== 'string' || data.raffle_id !== cfg.raffle || typeof data.base_entries_per_dollar !== 'number' || data.base_entries_per_dollar !== 200) throw new Error('WRONG_ACTIVE');
    var current = data.current;
    if (current && typeof current.starts_at === 'string' && typeof current.ends_at === 'string' && typeof current.entries_per_dollar === 'number' && current.entries_per_dollar === 300) {
      var currentStart = Date.parse(current.starts_at), currentEnd = Date.parse(current.ends_at);
      if (!Number.isFinite(currentStart) || !Number.isFinite(currentEnd) || currentStart !== start || currentEnd <= currentStart || currentEnd > end) throw new Error('UNVERIFIED_BONUS');
      if (t < currentEnd) return { phase: 'active', base_rate: 300, bonus_end: current.ends_at, validUntil: Math.min(currentEnd, t + 60000) };
    }
    return { phase: 'active', base_rate: 200, validUntil: Math.min(end, t + 60000) };
  }
  async function refreshProjection() {
    if (projectionFlight) return projectionFlight;
    projectionFlight = (async function () {
      var api = window.KaidoPublicSnapshot;
      await api.ready;
      var data = api.get();
      if (!data) { await api.refresh(); data = api.get(); }
      var item = roots.values().next().value;
      if (!item) return;
      var t = api.now();
      var start = data && Date.parse(data.raffle.starts_at), end = data && Date.parse(data.raffle.ends_at);
      if (!data || !Number.isFinite(t) || data.raffle.id !== item.cfg.raffle ||
          !Number.isFinite(start) || !Number.isFinite(end) || start >= end) {
        if (!Number.isFinite(now()) || now() >= state.validUntil) clear();
        retryAt = performance.now() + 15000;
        return;
      }
      anchor = { time: t, mono: performance.now() };
      // The fresh, validated Shopify snapshot owns dates; theme dates are legacy defaults.
      var lease = Math.min(Date.parse(data.valid_until), Date.parse(data.generated_at) + 300000);
      if (t >= end || data.raffle.status === 'ended') {
        publish({ phase: 'ended', base_rate: 0, validUntil: lease, policy_hash: data.policy_hash,
          giveaway_start: data.raffle.starts_at, giveaway_end: data.raffle.ends_at }); return;
      }
      if (data.raffle.status === 'upcoming' || data.raffle.status === 'staged') {
        publish({ phase: 'prestart', planned_start: data.raffle.status === 'staged', base_rate: 0, validUntil: lease, policy_hash: data.policy_hash,
          giveaway_start: data.raffle.starts_at, giveaway_end: data.raffle.ends_at }); return;
      }
      if (!api.active()) { clear(); return; }
      var rate = api.rate(), next = { phase: 'active', base_rate: rate,
        social_quantity: data.social_bonus, validUntil: lease, policy_hash: data.policy_hash,
        giveaway_start: data.raffle.starts_at, giveaway_end: data.raffle.ends_at };
      var windowRow = data.windows.filter(function (row) {
        return row.enabled && row.rate === rate && rate > data.base_rate && Date.parse(row.starts_at) <= t && t < Date.parse(row.ends_at);
      }).sort(function (a, b) { return Date.parse(a.ends_at) - Date.parse(b.ends_at); })[0];
      if (windowRow) next.bonus_end = windowRow.ends_at;
      if (data.daily && data.daily.enabled && Date.parse(data.daily.starts_at) <= t && t < Date.parse(data.daily.ends_at)) next.daily_bonus_end = data.daily.ends_at;
      publish(next);
    })();
    try { return await projectionFlight; } finally { projectionFlight = null; }
  }
  async function refresh() {
    if (window.KaidoPublicSnapshot) return refreshProjection();
    if (flight) { rerun = true; return flight; }
    var item = roots.values().next().value; if (!item) return;
    var cfg = item.cfg, own = ++generation; now();
    var abort = new AbortController(), deadline = setTimeout(function () { abort.abort(); }, 8000);
    flight = (async function () {
      try {
        var url = new URL(location.href); url.searchParams.set('section_id', cfg.section); if (!crypto || typeof crypto.randomUUID !== 'function') throw new Error('UNTRUSTED_CLOCK'); url.searchParams.set('_kaido_clock', crypto.randomUUID());
        var began = performance.now();
        var clock = await fetch(url.href, { method: 'GET', cache: 'no-store', credentials: 'same-origin', signal: abort.signal });
        var sampled = performance.now(), age = Number(clock.headers.get('Age') || 0), date = Date.parse(clock.headers.get('Date') || '');
        if (!clock.ok || !Number.isFinite(date) || !Number.isFinite(age) || age > 0 || age < 0 || sampled - began > 5000) throw new Error('UNTRUSTED_CLOCK');
        if (anchor) floor = Math.max(floor, anchor.time + sampled - anchor.mono);
        // HTTP Date is second-precision; tolerate truncation without reversing known time.
        if (date < floor - 1000) throw new Error('REGRESSING_CLOCK');
        anchor = { time: Math.max(date, floor), mono: sampled };
        var headers = { apikey: cfg.key, 'Content-Type': 'application/json' };
        var results = await Promise.all([
          fetch(cfg.url + '/functions/v1/get_active_bonus_window', { headers: headers, cache: 'no-store', signal: abort.signal }).then(function (response) { if (!response.ok) throw new Error('BACKEND_UNAVAILABLE'); return response.json(); }),
          fetch(cfg.url + '/rest/v1/raffle_settings?setting_key=eq.social_bonus_base_value&select=setting_value&limit=1', { headers: headers, cache: 'no-store', signal: abort.signal })
            .then(function (response) { return response.ok ? response.json() : null; }).then(function (rows) { var n = rows && rows[0] && Number(rows[0].setting_value); return Number.isInteger(n) && n > 0 ? n : null; }).catch(function () { return null; }),
          fetch(cfg.url + '/functions/v1/get_daily_bonus_products', { headers: headers, cache: 'no-store', signal: abort.signal })
            .then(function (response) { return response.ok ? response.json() : null; }).catch(function () { return null; })
        ]);
        var data = results[0]; if (own !== generation) return;
        if (typeof cfg.raffle !== 'string' || typeof cfg.start !== 'string' || typeof cfg.end !== 'string') throw new Error('BAD_SCHEDULE');
        var t = now(), start = Date.parse(cfg.start), end = Date.parse(cfg.end);
        if (![t, start, end].every(Number.isFinite) || !(start < end)) throw new Error('BAD_SCHEDULE');
        if (t >= end) { publish({ phase: 'ended', base_rate: 0, validUntil: Infinity }); return; }
        if (t < start) {
          var upcoming = data.upcoming_raffle;
          if (!upcoming || typeof upcoming.id !== 'string' || upcoming.id !== cfg.raffle || typeof upcoming.start_date !== 'string') throw new Error('WRONG_UPCOMING');
          var upcomingStart = Date.parse(upcoming.start_date), plannedOnly = upcomingStart === Date.parse('2999-12-31T00:00:00Z');
          if (upcomingStart !== start && !plannedOnly) throw new Error('WRONG_UPCOMING');
          publish({ phase: 'prestart', planned_start: plannedOnly, base_rate: 0, validUntil: Math.min(start, t + 60000) }); return;
        }
        if (data.upcoming_raffle && typeof data.upcoming_raffle.start_date === 'string' && Date.parse(data.upcoming_raffle.start_date) === Date.parse('2999-12-31T00:00:00Z')) throw new Error('STAGED_NOT_ARMED');
        var activeState = resolveActiveState(data, cfg, t, start, end);
        activeState.social_quantity = results[1];
        activeState.daily_bonus_end = resolveDailyBonusEnd(results[2], t, end);
        if (activeState.daily_bonus_end) activeState.validUntil = Math.min(activeState.validUntil, Date.parse(activeState.daily_bonus_end));
        publish(activeState);
      } catch (_) {
        if (own === generation) {
          var failedAt = now();
          if (state.phase === 'unknown' || !Number.isFinite(failedAt) || (state.validUntil !== Infinity && failedAt >= state.validUntil)) {
            anchor = null;
            clear();
          }
          retryAt = performance.now() + 15000;
        }
      }
      finally { clearTimeout(deadline); }
    })();
    try { await flight; } finally { flight = null; if (rerun) { rerun = false; refresh(); } }
  }
  function boundary() { generation++; refresh(); }
  function mount() {
    roots.forEach(function (item, id) { if (!item.root.isConnected) { if (item.progress) item.progress.dispose(); roots.delete(id); } });
    document.querySelectorAll('script[data-kaido-launch-config]').forEach(function (node) {
      var cfg; try { cfg = JSON.parse(node.textContent); } catch (_) { return; }
      var root = document.getElementById(cfg.root); if (!root || cfg.enabled !== true) return;
      var tuple = JSON.stringify([cfg.raffle, cfg.start, cfg.end, cfg.url, cfg.key]);
      if (authority === null) authority = tuple;
      if (tuple !== authority) {
        var rejected = roots.get(cfg.root);
        if (rejected && rejected.progress) { rejected.progress.dispose(); rejected.progress = null; }
        roots.delete(cfg.root); hide(root, true);
        root.setAttribute('data-kaido-authority-rejected', '');
        root.setAttribute('data-kaido-state', 'unknown'); return;
      }
      if (root.hasAttribute('data-kaido-authority-rejected')) {
        hide(root, false); root.removeAttribute('data-kaido-authority-rejected');
      }
      if (roots.has(cfg.root)) return;
      var content = root.querySelector('.kh3__content'), before = document.createDocumentFragment();
      var beforeTemplate = root.querySelector('template[data-kaido-before]');
      if (beforeTemplate) before.appendChild(beforeTemplate.content.cloneNode(true));
      else if (content) Array.from(content.childNodes).forEach(function (child) { before.appendChild(child.cloneNode(true)); });
      var subheading = root.querySelector('.kh3__subheading');
      var item = { root: root, cfg: cfg, before: before, needsPaint: true, originalSubheading: subheading ? subheading.textContent : '', activeTemplate: root.querySelector('template[data-kaido-active]'), active: root.getAttribute('data-kh3-phase') === 'active' && !!beforeTemplate };
      root.addEventListener('click', function (event) {
        var button = event.target.closest('.kh3__expander-btn'); if (!button || !item.active) return;
        var open = button.getAttribute('aria-expanded') === 'true'; button.setAttribute('aria-expanded', open ? 'false' : 'true');
        button.classList.toggle('is-open', !open);
        var panel = root.querySelector('.kh3__expander-content'); if (panel) panel.classList.toggle('is-open', !open);
      });
      roots.set(cfg.root, item);
      if (!window.KaidoPublicSnapshot) paint(item);
    });
    if (!roots.size) { generation++; anchor = null; clear(); }
    else if (!flight) refresh();
  }
  window.kaidoLaunchLifecycle = { mount: mount, refresh: refresh, boundary: boundary };
  document.addEventListener('kaido:public-snapshot', function () { if (roots.size) refresh(); });
  setInterval(function () {
    if (!roots.size) return;
    // Preserve SSR during the bounded initial trusted-clock flight, not after failure.
    if (window.KaidoPublicSnapshot && !anchor && projectionFlight) return;
    if (window.KaidoPublicSnapshot && state.validUntil && now() >= state.validUntil && !window.KaidoPublicSnapshot.get()) clear();
    if ((state.validUntil && now() >= state.validUntil) || (!anchor && performance.now() >= retryAt && !flight)) boundary();
    else roots.forEach(paint);
  }, 1000);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    var currentTime = now();
    if (state.phase === 'unknown' || !Number.isFinite(currentTime) || (state.validUntil !== Infinity && currentTime >= state.validUntil)) boundary();
    else refresh();
  });
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', function (event) {
    roots.forEach(function (item, id) { if (event.target.contains(item.root)) { if (item.progress) item.progress.dispose(); roots.delete(id); } });
    if (!roots.size) { generation++; anchor = null; clear(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
